import uiRouter from '@uirouter/angularjs/lib-esm'
/*import user from '../SlotTrak.User'*/

import resetPasswordController from './controller'
import resetPasswordDirective from './directive'
import resetPasswordRoutes from './routes'

var mod = angular.module('SlotTrak.ResetPassword', [
  uiRouter,
  /*user*/
])

mod
  .config(resetPasswordRoutes)
  .controller('ResetPasswordController', resetPasswordController)
  .directive('resetPassword', resetPasswordDirective)

export default mod.name
